import { render, staticRenderFns } from "./detailReceive.vue?vue&type=template&id=250c63d2"
import script from "./detailReceive.vue?vue&type=script&lang=js"
export * from "./detailReceive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports